import IconBase from './IconBase'
import { ReactComponent } from './custom/playbook.svg'

const Icon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default Icon
